import {Injectable} from '@angular/core';

import {SubjectService} from '../services/subject/subject.service';

@Injectable({providedIn: 'root'})
export class SubjectFacade {
  public subject$     = this._service.subject$;
  public subjectId$   = this._service.subjectId$;
  public subjects$    = this._service.subjects$;
  public subjectsMap$ = this._service.subjectsMap$;

  constructor(private readonly _service: SubjectService) {}

  public updateSubjectId(id: string): void {
    this._service.updateSubjectId(id);
  }

  public enableAll = this._service.enableAll.bind(this._service);
}
